export default __webpack_public_path__ + "locales/sr-Latn-RS/EmptyTrashDialog.json?hash=896bd60c3cde17e59bf6a2849d868caa";